/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydownload2Inputs */

const en_medialibrarydownload2 = /** @type {(inputs: Medialibrarydownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const de_medialibrarydownload2 = /** @type {(inputs: Medialibrarydownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Medialibrarydownload2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydownload2 = /** @type {((inputs?: Medialibrarydownload2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydownload2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydownload2(inputs)
	return de_medialibrarydownload2(inputs)
});
export { medialibrarydownload2 as "mediaLibraryDownload" }